import type { ReactNode } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';

type PageHeaderProps = {
  eyebrow: string;
  title: string;
  description: string;
  /// A text is drawn as a neutral chip; a state passes its own `StatusChip` (#285).
  badge?: ReactNode;
};

export function PageHeader({ eyebrow, title, description, badge }: PageHeaderProps) {
  return (
    <Stack spacing={2}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        spacing={1.5}
      >
        <Box>
          <Typography
            variant="overline"
            color="primary.main"
            sx={{ letterSpacing: '0.12em', fontWeight: 800 }}
          >
            {eyebrow}
          </Typography>
          <Typography variant="h2" component="h1">
            {title}
          </Typography>
        </Box>
        {badge && typeof badge !== 'string' ? (
          <Box sx={{ alignSelf: { xs: 'flex-start', sm: 'center' } }}>{badge}</Box>
        ) : badge ? (
          <Chip
            label={badge}
            variant="outlined"
            sx={{
              borderColor: '#D5D9DF',
              color: 'text.primary',
              alignSelf: { xs: 'flex-start', sm: 'center' },
            }}
          />
        ) : null}
      </Stack>
      <Typography variant="body1" color="text.secondary" maxWidth={760}>
        {description}
      </Typography>
    </Stack>
  );
}
